import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import Draggable from 'owa-dnd/lib/components/Draggable';
import * as React from 'react';
var styles = require('./DraggableItem.scss');
var DRAG_X_OFFSET = -10;
var DRAG_Y_OFFSET = 5;
var DraggableItem = /** @class */ (function (_super) {
    tslib_1.__extends(DraggableItem, _super);
    function DraggableItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDragEnd = function (dragData, dropEffect) {
            // If succesfully dropped, the dropEffect should be set to 'move'
            if (dropEffect && dropEffect == 'move') {
                _this.props.removeDroppedItemAction(_this.props.item);
            }
        };
        return _this;
    }
    DraggableItem.prototype.render = function () {
        var _this = this;
        return (React.createElement(Draggable, { classNames: styles.draggableContainer, dragViewState: this.props.dragViewState, canDrag: function () { return _this.canDrag(); }, getDragData: function () { return _this.getDragData(); }, getDragPreview: this.getDragPreview, xOffset: DRAG_X_OFFSET, yOffset: DRAG_Y_OFFSET, onDragEnd: this.onDragEnd }, this.props.children));
    };
    DraggableItem.prototype.canDrag = function () {
        var item = this.props.item;
        return this.props.canDrag(item);
    };
    DraggableItem.prototype.getDragData = function () {
        var wellItemDragData = {
            itemType: this.props.draggableItemType,
            item: this.props.item,
            displayText: this.props.displayText,
        };
        return wellItemDragData;
    };
    DraggableItem.prototype.getDragPreview = function (dragData) {
        var elem = document.createElement('div');
        elem.innerText = dragData.displayText;
        return elem;
    };
    DraggableItem = tslib_1.__decorate([
        observer
    ], DraggableItem);
    return DraggableItem;
}(React.Component));
export default DraggableItem;
//# sourceMappingURL=DraggableItem.js.map